import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { SettingApiService } from './setting-api.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { GenericResponse } from '../generic-response';
import { Subject } from 'rxjs';
import { User } from 'src/app/core/model/user-model';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(
    private location: Location,
    private router: Router,
    private settingApiService: SettingApiService,
    private routeAnimationShared: RouteAnimationShared
  ) {}
  public bottomSheet: Subject<{
    show: boolean;
    data: { selected: string; user?: User; blogUser?: BlogUserModel };
  }> = new Subject();
  public closeBottomSheet: Subject<{ show: false }> = new Subject();
  goBack() {
    this.routeAnimationShared.showRouteAnimation();
    this.location.back();
  }

  goToSetting() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/setting']);
  }
  goToAnswer(id: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/faqanswer/' + id]);
  }
  goToAboutUs() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/aboutus']);
  }

  goToFAQ(data: { id: string; title: string }) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/faq/' + data.id], {
      state: { title: data.title },
    });
  }
  goToMessageInbox() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/message']);
  }
  goToSupportPage() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/support']);
  }

  goToReportProblem() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/reportproblem']);
  }

  goToPersonalInformation() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/personalinfo']);
  }

  goToBlogInformation() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/tribunesetting']);
  }
  goToMessagePage(id: string) {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate(['/messagepage/' + id]);
  }
  sendProblem(text: string): Promise<GenericResponse> {
    return this.settingApiService.sendProblem(text);
  }
}
